// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import TotalDubai from '@/assets/img/madina-haram.png';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import carParkIcon from '@/assets/img/car-park-1.png';
// import { API_CALL_TIME } from '@/constants/constant';


// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// // ═══════════════════════════════════════════════════════════════════════
// // ASSET GROUPS HELPER
// // ═══════════════════════════════════════════════════════════════════════
// function makeAssetGroups(o = {}) {
//   return [
//     { group_name: 'Ticket Dispenser', group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: o.g10064 ?? '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//     { group_name: 'Ticket Verifier', group_total_qty: o.ticketVerifier ?? '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//     { group_name: "APM's", group_total_qty: o.apms ?? '-', items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: o.apmEts100 ?? '-' }] },
//     { group_name: 'PIN Pad', group_total_qty: o.pinPad ?? '-', items: [{ item_name: 'IUP250', qty: o.pinPad ?? '-' }] },
//     { group_name: 'Card Reader', group_total_qty: o.cardReader ?? '-', items: [{ item_name: 'IUR250', qty: o.cardReader ?? '-' }] },
//     { group_name: 'B-Contactless', group_total_qty: o.bContactless ?? '-', items: [{ item_name: 'IUC150', qty: o.bContactless ?? '-' }] },
//     { group_name: 'RFID Reader', group_total_qty: o.rfidReader ?? '-', items: [] },
//     { group_name: 'IP Barrier', group_total_qty: o.ipBarrier ?? '-', items: [] },
//     { group_name: 'ANPR CAMERA', group_total_qty: o.anprCamera ?? '-', items: [{ item_name: 'ARH', qty: '-' }, { item_name: 'Luminera', qty: o.luminera ?? '-' }] },
//     { group_name: 'Sliding Gate', group_total_qty: '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
//     { group_name: "PND's", group_total_qty: '-', items: [{ item_name: 'TPAL- BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
//     { group_name: 'Pound Cahier Device', group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
//     { group_name: 'Driver Device', group_total_qty: '-', items: [{ item_name: 'CN-51', qty: '-' }] },
//     { group_name: 'Enf Device', group_total_qty: o.enfDevice ?? '-', items: [{ item_name: 'Oukitel WP2', qty: o.oukitel ?? '-' }, { item_name: 'Doogee V10', qty: '-' }] },
//     { group_name: 'Validation', group_total_qty: '-', items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//     { group_name: 'Printer', group_total_qty: o.printer ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
//     { group_name: 'Tow Truck', group_total_qty: '-', items: [] },
//     { group_name: 'Clamp Vehicle', group_total_qty: o.clampVehicle ?? '-', items: [] },
//   ];
// }

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG — Madinah Haram ke teeno page types
// // ═══════════════════════════════════════════════════════════════════════
// const MADINAH_PROFILE_CONFIG = {

//   // ── Madinah Haram Profile (main profile + casual parking + membership) ──
//   madinah_haram_profile: {
//     profileKey: 'madinah_haram_profile',
//     casualKey: 'madinah_haram_casual_parking',
//     membershipKey: 'madinah_haram_membership_tariff',
//     assetsKey: 'madinah_haram_assets',
//     pageType: 'profile',   // profile | parking | enforcement

//     profileFallback: {
//       table_key: 'madinah_haram_profile',
//       title: 'Madinah Haram Profile',
//       data: {
//         car_park_bays: { label: 'Madinah Haram Car Park Bays', value: '4272' },
//         contract_term: { value: '03 years' },
//         contract_period: { start_date: '01/02/2024', end_date: '31/01/2027' },
//         operational_hours: { value: '24 Hours Per day' },
//         parking_tariff: { value: 'As per below tariff table excluding 15% vat' },
//         membership_tariff: { value: 'As per below tariff table excluding 15% vat' },
//       },
//     },

//     casualFallback: {
//       table_key: 'madinah_haram_casual_parking',
//       title: 'Casual Parking Per Hour',
//       data: {
//         locationRows: [
//           { location: 'A-1', bays: '178' }, { location: 'A-2', bays: '178' },
//           { location: 'A-3', bays: '178' }, { location: 'A-4', bays: '178' },
//           { location: 'A-5', bays: '178' }, { location: 'A-6', bays: '178' },
//           { location: 'A-7', bays: '178' }, { location: 'A-8', bays: '178' },
//           { location: 'A-9', bays: '178' }, { location: 'A-10', bays: '178' },
//           { location: 'A-11', bays: '178' }, { location: 'B-1', bays: '178' },
//           { location: 'B-2', bays: '178' }, { location: 'B-3', bays: '178' },
//           { location: 'B-4', bays: '178' }, { location: 'B-5', bays: '178' },
//           { location: 'B-6', bays: '178' }, { location: 'B-7', bays: '178' },
//           { location: 'B-8', bays: '178' }, { location: 'B-9', bays: '178' },
//           { location: 'B-10', bays: '178' }, { location: 'B-11', bays: '178' },
//           { location: 'B-12', bays: '178' }, { location: 'B-13', bays: '178' },
//         ],
//         tariffRows: [
//           { location: 'A-1', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-3', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-4', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-5', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-7', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-8', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-9', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-10', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-11', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-1', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-3', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-4', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-5', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-7', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-9', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-11', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-12', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//         ],
//       },
//     },

//     membershipFallback: {
//       table_key: 'madinah_haram_membership_tariff',
//       title: 'Membership Tariff',
//       data: {
//       columns: [
//   'Location',
//   '1 Month Employee',
//   '1 Month',
//   '1 Month',
//   '1 Month',
//   '1 Month',
//   '1 Month',
//   '1 Month RAMADAN',
//   '2 Months',
//   '2 Months',
//   '3 Months',
//   '3 Months',
//   '6 Months',
//   '6 Months',
//   '12 Months',
//   '12 Months',
//   '12 Months',
//   '12 Months',
//   '12 Months'
// ],
//         rows: [
//           ['A-2', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
//           ['A-3', '100', '', '', '', '', '400', '1440', '', '', '', '', '', '', '', '', '', '', '5,120'],
//           ['A-4', '100', '', '300', '', '', '', '1440', '', '', '', '', '', '', '', '4,020', '', '', ''],
//           ['A-6', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
//           ['B-2', '100', '', '', '350', '', '', '1440', '700', '', '1,050', '', '2,100', '', '', '', '4,570', '', ''],
//           ['B-4', '100', '275', '', '', '', '', '1440', '', '', '', '', '', '', '3,745', '', '', '', ''],
//           ['B-6', '100', '', '', '350', '', '', '1440', '700', '', '1,050', '', '2,100', '', '', '', '4,570', '', ''],
//           ['B-8', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
//           ['B-10', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
//           ['B-13', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'madinah_haram_assets',
//       title: 'Madinah Harram Contract',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '24', g10064: '24', ticketVerifier: '26', evG10064: '26',
//           apms: '48', apmEts70: '30', apmEts100: '18', pinPad: '35',
//           bContactless: '35', rfidReader: '50', ipBarrier: '50', anprCamera: '50',
//           luminera: '50', printer: '-', enfDevice: '-',
//         }),
//       },
//     },
//   },

//   // ── Madinah Haram Parking Profile ──────────────────────────────────
//   madinah_haram_parking_profile: {
//     profileKey: 'madinah_haram_parking_profile',
//     casualKey: 'madinah_haram_parking_casual',
//     membershipKey: 'madinah_haram_parking_membership',
//     assetsKey: 'madinah_haram_parking_assets',
//     pageType: 'parking',

//     profileFallback: {
//       table_key: 'madinah_haram_parking_profile',
//       title: 'Madinah Haram Parking Profile',
//       data: {
//         car_park_bays: { label: 'Madinah Haram Car Park Bays', value: '4272' },
//         contract_term: { value: '03 years' },
//         contract_period: { start_date: '01/02/2024', end_date: '31/01/2027' },
//         operational_hours: { value: '24 Hours Per day' },
//         parking_tariff: { value: 'As per below tariff table excluding 15% vat' },
//         membership_tariff: { value: 'As per below tariff table excluding 15% vat' },
//       },
//     },

//     casualFallback: {
//       table_key: 'madinah_haram_parking_casual',
//       title: 'Casual Parking Per Hour',
//       data: {
//         locationRows: [
//           { location: 'A-1', bays: '178' }, { location: 'A-2', bays: '178' },
//           { location: 'A-3', bays: '178' }, { location: 'A-4', bays: '178' },
//           { location: 'A-5', bays: '178' }, { location: 'A-6', bays: '178' },
//           { location: 'A-7', bays: '178' }, { location: 'A-8', bays: '178' },
//           { location: 'A-9', bays: '178' }, { location: 'A-10', bays: '178' },
//           { location: 'A-11', bays: '178' }, { location: 'B-1', bays: '178' },
//           { location: 'B-2', bays: '178' }, { location: 'B-3', bays: '178' },
//           { location: 'B-4', bays: '178' }, { location: 'B-5', bays: '178' },
//           { location: 'B-6', bays: '178' }, { location: 'B-7', bays: '178' },
//           { location: 'B-8', bays: '178' }, { location: 'B-9', bays: '178' },
//           { location: 'B-10', bays: '178' }, { location: 'B-11', bays: '178' },
//           { location: 'B-12', bays: '178' }, { location: 'B-13', bays: '178' },
//         ],
//         tariffRows: [
//           { location: 'A-1', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-3', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-4', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-5', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-7', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-8', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-9', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-10', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'A-11', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-1', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-3', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-4', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-5', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-7', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-9', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-11', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//           { location: 'B-12', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
//         ],
//       },
//     },

//     membershipFallback: {
//       table_key: 'madinah_haram_parking_membership',
//       title: 'Membership Tariff',
//       data: {
//         columns: ['Location', '1 Month Employee', '1 Month', '1 Month', '1 Month', '1 Month', '1 Month', '1 Month RAMDAN', '2 Months', '2 Months', '3 Months', '3 Months', '6 Months', '6 Months', '12 Months', '12 Months', '12 Months', '12 Months', '12 Months'],
//         rows: [
//           ['A-2', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
//           ['A-3', '100', '', '', '', '', '400', '1440', '', '', '', '', '', '', '', '', '', '', '5,120'],
//           ['A-4', '100', '', '300', '', '', '', '1440', '', '', '', '', '', '', '', '4,020', '', '', ''],
//           ['A-6', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
//           ['B-2', '100', '', '', '350', '', '', '1440', '700', '', '1,050', '', '2,100', '', '', '', '4,570', '', ''],
//           ['B-4', '100', '275', '', '', '', '', '1440', '', '', '', '', '', '', '3,745', '', '', '', ''],
//           ['B-6', '100', '', '', '350', '', '', '1440', '700', '', '1,050', '', '2,100', '', '', '', '4,570', '', ''],
//           ['B-8', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
//           ['B-10', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
//           ['B-13', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'madinah_haram_parking_assets',
//       title: 'Madinah Harram Off-Street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '24', g10064: '24', ticketVerifier: '26', evG10064: '26',
//           apms: '48', apmEts70: '30', apmEts100: '18', pinPad: '35',
//           bContactless: '35', rfidReader: '50', ipBarrier: '50', anprCamera: '50',
//           luminera: '50', printer: '-', enfDevice: '-',
//         }),
//       },
//     },
//   },

//   // ── Madinah Haram Enforcement Profile ──────────────────────────────
//   madinah_haram_enforcement_profile: {
//     profileKey: 'madinah_haram_enforcement_profile',
//     enforcementKey: 'madinah_haram_enforcement_violations',
//     assetsKey: 'madinah_haram_enforcement_assets',
//     pageType: 'enforcement',

//     profileFallback: {
//       table_key: 'madinah_haram_enforcement_profile',
//       title: 'Madinah Haram Enforcement Profile',
//       data: {
//         car_park_bays: { label: 'Madinah Haram Car Park Bays', value: '4272' },
//         contract_term: { value: '03 years' },
//         contract_period: { start_date: '01/02/2024', end_date: '31/01/2027' },
//         operational_hours: { value: '24 Hours Per day' },
//         enforcement_tariff: { value: 'excluding 15% vat' },
//       },
//     },

//     enforcementFallback: {
//       table_key: 'madinah_haram_enforcement_violations',
//       title: 'Enforcement Violations',
//       data: {
//         rows: [
//           { sno: '11', code: '801', category: 'MED', description_en: 'Parked in a non-parking area', description_ar: 'الوقوف ضمن منطقة ممنوع الوقوف فيها - 801', fine: '150', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
//           { sno: '12', code: '802', category: 'MED', description_en: 'Parked on pedestrian or buildings entries', description_ar: 'الوقوف عند مداخل المشاة أو مداخل المباني - 802', fine: '200', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
//           { sno: '13', code: '803', category: 'MED', description_en: 'Parked on the pavement or on a pedestrian area', description_ar: 'الوقوف على الرصيف أو في مكان عبور المشاة - 803', fine: '150', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
//           { sno: '14', code: '804', category: 'MED', description_en: 'Parked facing the opposite direction of traffic flow', description_ar: 'الوقوف بشكل معاكس لاتجاه السير - 804', fine: '150', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
//           { sno: '15', code: '805', category: 'MED', description_en: 'Parked in an officially reserved space', description_ar: 'الوقوف في مكان تم حجزه رسمياً - 805', fine: '150', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
//           { sno: '16', code: '806', category: 'MED', description_en: 'Parked in a suspended space/temporary out of use', description_ar: 'الوقوف في حيز معلق الاستخدام - 806', fine: '150', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
//           { sno: '17', code: '807', category: 'MED', description_en: 'Placing obstacles or reservations on the parking space', description_ar: 'وضع حواجز أو معوقات على حيز الوقوف - 807', fine: '300', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
//           { sno: '18', code: '808', category: 'MED', description_en: 'Fencing or closing a parking space without a valid permit', description_ar: 'تسوير وإغلاق موقف بدون تصريح - 808', fine: '200', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
//           { sno: '19', code: '809', category: 'MED', description_en: 'Parked outside allowed time', description_ar: 'تجاوز الفترة المسموح به الإيقاف - 809', fine: '100', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
//           { sno: '20', code: '810', category: 'MED', description_en: 'Parked in violation of posted signs', description_ar: 'الوقوف بشكل مخالف للوحات الإيقاف - 810', fine: '150', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
//           { sno: '21', code: '811', category: 'MED', description_en: 'Parked on a fire hydrant bay', description_ar: 'الوقوف إلى جانب طلمبات الحريق بمسافة تقل عن (3) أمتر - 811', fine: '250', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
//           { sno: '22', code: '815', category: 'MED', description_en: 'Parked in a non-parking area ? H', description_ar: 'الوقوف في موقع غير مخصص للوقوف ؟ح- 815', fine: '0', discount: '150', after_discount: '150', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'madinah_haram_enforcement_assets',
//       title: 'Madinah Harram Off-Street Enf',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '-', ticketVerifier: '-', apms: '-', pinPad: '-',
//           cardReader: '-', bContactless: '-', rfidReader: '-', ipBarrier: '-',
//           anprCamera: '-', enfDevice: '6', oukitel: '6', printer: '4', pr3: '4',
//           clampVehicle: '1',
//         }),
//       },
//     },
//   },
// };


// // ═══════════════════════════════════════════════════════════════════════
// // PROFILE HEADER (reusable for all 3 pages)
// // ═══════════════════════════════════════════════════════════════════════
// const ProfileHeader = ({ pd, pageType, patchProfile }) => (
//   <div className="flex-1 pr-4">
//     {/* Car Park Bays */}
//     <div className="flex items-center gap-2 mb-1 ml-4 mt-2">
//       <img src={carParkIcon} alt="car park" style={{ height: '30px', objectFit: 'contain' }} />

//       {/* <div className="w-4 h-4 !border-2 !border-blue-600 flex-shrink-0" /> */}
//       <span className="text-[12px]">
//         {pd.car_park_bays?.label}{' '}
//         <strong>
//           <input type="text" value={pd.car_park_bays?.value || ''}
//             onChange={e => patchProfile('car_park_bays', 'value', e.target.value)}
//             className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" />
//         </strong>
//       </span>
//     </div>

//     {/* Contract Term */}
//     <div className="flex items-start gap-2 mb-1 ml-10">
//       <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//       <span className="text-[12px]  gap-06">
//         Contract term{''}
//         <strong><input type="text" value={pd.contract_term?.value || ''}
//           onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//           className="font-bold outline-none bg-transparent !border-0 text-[12px] ml-2 w-13" /></strong>
//         ; start date{' '}
//         <strong><input type="text" value={pd.contract_period?.start_date || ''}
//           onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//           className="font-bold outline-none bg-transparent !border-0 text-[12px] w-18" /></strong>
//         {' to '}
//         <strong><input type="text" value={pd.contract_period?.end_date || ''}
//           onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//           className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
//       </span>
//     </div>
//     {/* <div className="flex items-start gap-2 mb-1 ml-10">
//       <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//       <span className="text-[12px] flex items-center flex-wrap gap-1">
//         Contract term{' '}
//         <strong><input type="text" value={pd.contract_term?.value || ''}
//           onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//           className="font-bold outline-none bg-transparent !border-0 text-[12px] " /></strong>
//         ; start date{' '}
//         <strong><input type="text" value={pd.contract_period?.start_date || ''}
//           onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//           className="font-bold outline-none bg-transparent !border-0 text-[12px] " /></strong>
//         {' to '}
//         <strong><input type="text" value={pd.contract_period?.end_date || ''}
//           onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//           className="font-bold outline-none bg-transparent !border-0 text-[12px] " /></strong>
//       </span>
//     </div> */}

//     {/* Operational Hours */}
//     <div className="flex items-center gap-2 mb-1 ml-10">
//       <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//       <span className="text-[12px]">
//         Operational Hours{' '}
//         <strong><input type="text" value={pd.operational_hours?.value || ''}
//           onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
//           className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
//       </span>
//     </div>

//     {/* Tariff line — profile & parking: 2 lines, enforcement: 1 line */}
//     {pageType !== 'enforcement' && (
//       <>
//         <div className="flex items-center gap-2 mb-1 ml-10">
//           <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//           <span className="text-[12px]">
//             Parking Tariff –{' '}
//             <strong><input type="text" value={pd.parking_tariff?.value || ''}
//               onChange={e => patchProfile('parking_tariff', 'value', e.target.value)}
//               className="font-bold outline-none bg-transparent !border-0 text-[12px] w-64" /></strong>
//           </span>
//         </div>
//         <div className="flex items-center gap-2 mb-1 ml-10">
//           <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//           <span className="text-[12px]">
//             Membership Tariff -{' '}
//             <strong><input type="text" value={pd.membership_tariff?.value || ''}
//               onChange={e => patchProfile('membership_tariff', 'value', e.target.value)}
//               className="font-bold outline-none bg-transparent !border-0 text-[12px] w-64" /></strong>
//           </span>
//         </div>
//       </>
//     )}
//     {pageType === 'enforcement' && (
//       <div className="flex items-center gap-2 mb-1 ml-10">
//         <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//         <span className="text-[12px]">
//           <span>Enforcement violation tariff below {" "}</span>
//           <strong><input type="text" value={pd.enforcement_tariff?.value || ''}
//             onChange={e => patchProfile('enforcement_tariff', 'value', e.target.value)}
//             className="outline-none bg-transparent !border-0 text-[12px] w-80" /></strong>
//         </span>
//       </div>
//     )}

//     {/* Assets Deployed bullet */}
//     <div className="flex items-center gap-2 mb-3 ml-10">
//       <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//       <span className="text-[12px]">Assets Deployed</span>
//     </div>
//   </div>
// );

// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const MadinahHaramProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
  
//   const cfg = MADINAH_PROFILE_CONFIG[page?.type];
//   if (!cfg) return null;

//   const hasFetchedRef = useRef(false);
//   const saveRef = useRef(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [profileTable, setProfileTable] = useState(cfg.profileFallback);
//   const [assetsTable, setAssetsTable] = useState(cfg.assetsFallback);
//   const [casualTable, setCasualTable] = useState(cfg.casualFallback || null);
//   const [membershipTable, setMembershipTable] = useState(cfg.membershipFallback || null);
//   const [enforcementTable, setEnforcementTable] = useState(cfg.enforcementFallback || null);
//   const { enqueue } = useApiQueue();

//   const profileRef = useRef(null);
//   const assetsRef = useRef(null);
//   const casualRef = useRef(null);
//   const membershipRef = useRef(null);
//   const enforcementRef = useRef(null);

//   // Sync refs with latest state
//   useEffect(() => {
//     profileRef.current = profileTable;
//   }, [profileTable]);

//   useEffect(() => {
//     assetsRef.current = assetsTable;
//   }, [assetsTable]);

//   useEffect(() => {
//     casualRef.current = casualTable;
//   }, [casualTable]);

//   useEffect(() => {
//     membershipRef.current = membershipTable;
//   }, [membershipTable]);

//   useEffect(() => {
//     enforcementRef.current = enforcementTable;
//   }, [enforcementTable]);
//   // ── Fetch ────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     fetchData();
//   }, [year, monthNumber, contract]);

//   const fetchData = async () => {
//     try {
//       const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//       if (!res?.success) return;
//       const data = res?.data || [];
//       const find = (key, fb) => data.find(t => t.table_key === key) || fb;

//       setProfileTable(find(cfg.profileKey, cfg.profileFallback));
//       setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));

//       if (cfg.casualKey) setCasualTable(find(cfg.casualKey, cfg.casualFallback));
//       if (cfg.membershipKey) setMembershipTable(find(cfg.membershipKey, cfg.membershipFallback));
//       if (cfg.enforcementKey) setEnforcementTable(find(cfg.enforcementKey, cfg.enforcementFallback));
//     } catch (err) {
//       console.error('Fetch error:', err);
//     }
//   };

//   // ── Auto-save ─────────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveRef.current) clearTimeout(saveRef.current);
//     saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//   const saveToAPI = async () => {
//   try {
//     setIsSaving(true);

//     const tables = [];

//     // Profile aur Assets hamesha hote hain
//     if (profileRef.current) {
//       tables.push({ 
//         table_key: profileRef.current.table_key, 
//         title: profileRef.current.title, 
//         data: profileRef.current.data 
//       });
//     }
//     if (assetsRef.current) {
//       tables.push({ 
//         table_key: assetsRef.current.table_key, 
//         title: assetsRef.current.title, 
//         data: assetsRef.current.data 
//       });
//     }

//     if (casualRef.current) {
//       tables.push({ 
//         table_key: casualRef.current.table_key, 
//         title: casualRef.current.title, 
//         data: casualRef.current.data 
//       });
//     }
//     if (membershipRef.current) {
//       tables.push({ 
//         table_key: membershipRef.current.table_key, 
//         title: membershipRef.current.title, 
//         data: membershipRef.current.data 
//       });
//     }
//     if (enforcementRef.current) {
//       tables.push({ 
//         table_key: enforcementRef.current.table_key, 
//         title: enforcementRef.current.title, 
//         data: enforcementRef.current.data 
//       });
//     }

//     const res = await apiCall('POST', '/boardpack/add-tables-data', {
//       contract, 
//       year, 
//       month: monthNumber, 
//       created_by: 1, 
//       tables,
//     });

//     if (!res?.success) throw new Error(res?.message || 'Save failed');
    
//   } catch (err) {
//     console.error('Save error:', err);
//     toast.error('Failed to save changes');
//   } finally {
//     setIsSaving(false);
//   }
// };
//   // ── Patch helpers ─────────────────────────────────────────────────────
//   const patchProfile = (field, subField, value) => {
//     setProfileTable(prev => ({
//       ...prev,
//       data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
//     }));
//     autoSave();
//   };

//   const handleCasualLocationRow = (idx, key, value) => {
//     setCasualTable(prev => ({
//       ...prev,
//       data: { ...prev.data, locationRows: prev.data.locationRows.map((r, i) => i === idx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleCasualTariffRow = (idx, key, value) => {
//     setCasualTable(prev => ({
//       ...prev,
//       data: { ...prev.data, tariffRows: prev.data.tariffRows.map((r, i) => i === idx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleMembershipCell = (rIdx, cIdx, value) => {
//     setMembershipTable(prev => ({
//       ...prev,
//       data: {
//         ...prev.data,
//         rows: prev.data.rows.map((r, i) => i === rIdx ? r.map((c, j) => j === cIdx ? value : c) : r),
//       },
//     }));
//     autoSave();
//   };

//   const handleEnforcementCell = (rIdx, key, value) => {
//     setEnforcementTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleAssetSubCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const handleAssetTotalCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const handleCasualLocationHeader = (col, value) => {
//   setCasualTable(prev => ({
//     ...prev,
//     data: { ...prev.data, locationHeader: { ...prev.data.locationHeader, [col]: value } },
//   }));
//   autoSave();
// };

// const handleCasualTariffHeader = (key, value) => {
//   setCasualTable(prev => ({
//     ...prev,
//     data: { ...prev.data, tariffHeaders: { ...prev.data.tariffHeaders, [key]: value } },
//   }));
//   autoSave();
// };

// const handleMembershipColumn = (index, value) => {
//   setMembershipTable(prev => {
//     const newColumns = [...prev.data.columns];
//     newColumns[index] = value;
//     return { ...prev, data: { ...prev.data, columns: newColumns } };
//   });
//   autoSave();
// };

//   // ── Derived ───────────────────────────────────────────────────────────
//   const pd = profileTable.data;
//   const flatAssets = groupsToFlat(assetsTable.data.groups);
//   const pageType = cfg.pageType;

//   // ═══════════════════════════════════════════════════════════════════
//   // RENDER
//   // ═══════════════════════════════════════════════════════════════════
//   const groupedColumns = [
//   { label: 'Location', span: 1 },
//   { label: '1 Month Employee', span: 1 },
//   { label: '1 Month', span: 5 },
//   { label: '1 Month RAMDAN', span: 1 },
//   { label: '2 Months', span: 2 },
//   { label: '3 Months', span: 2 },
//   { label: '6 Months', span: 2 },
//   { label: '12 Months', span: 5 },
// ];
//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">
//       {/* Header */}
//       <div className="flex justify-between items-center mb-2">
//         <div className="ml-2">
//           {/* Replace with your Madinah logo import */}
//           <img src={TotalDubai} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} />        </div>
//         <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
//       </div>

//       <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">

//         {/* ══ LEFT ══ */}
//         <div className="flex-1">
//           <ProfileHeader pd={pd} pageType={pageType} patchProfile={patchProfile} />

//          {/* { ── Profile & Parking pages: Casual + Membership tables ──} */}
// {(pageType === 'profile' || pageType === 'parking') && casualTable && membershipTable && (
//   <div className="flex flex-row gap-3 ml-4 ">

//     {/* Casual Parking — left side (location list + tariff) */}
//     <div className="flex items-start gap-3 w-full">

//       {/* LEFT SIDE (Location + Tariff) */}
//       <div className="flex gap-2">

//         {/* Location + Bays column */}
//         <table className="!border-collapse text-[9px] w-auto">
//           <thead>
//             <tr>
//               <th className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold align-center" style={{ width: '70px' }}>
//                 <textarea
//                   rows={2}
//                   value={casualTable.data.locationHeader?.col1 || 'Location'}
//                   onChange={e => handleCasualLocationHeader('col1', e.target.value)}
//                   className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none overflow-hidden"
//                 />
//               </th>
//               <th className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold align-center" style={{ width: '80px' }}>
//                 <textarea
//                   rows={2}
//                   value={casualTable.data.locationHeader?.col2 || 'Parking Bays 4272'}
//                   onChange={e => handleCasualLocationHeader('col2', e.target.value)}
//                   className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none overflow-hidden"
//                 />
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {casualTable.data.locationRows.map((row, i) => (
//               <tr key={i}>
//                 <td className="!border !border-black px-1 py-0.5 text-center">
//                   <input type="text" value={row.location || ''} onChange={e => handleCasualLocationRow(i, 'location', e.target.value)} className="w-full min-w-0 !border-0 bg-transparent text-center outline-none text-[9px]" />
//                 </td>
//                 <td className="!border !border-black px-1 py-0.5 text-center">
//                   <input type="text" value={row.bays || ''} onChange={e => handleCasualLocationRow(i, 'bays', e.target.value)} className="w-full min-w-0 !border-0 bg-transparent text-center outline-none text-[9px]" />
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {/* Tariff columns */}
//         <table className="!border-collapse text-[9px] w-auto">
//           <thead>
//             <tr>
//               <th colSpan={5} className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold">
//                 <textarea
//                   rows={2}
//                   value={casualTable.title || ''}
//                   onChange={e => { setCasualTable(prev => ({ ...prev, title: e.target.value })); autoSave(); }}
//                   className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none overflow-hidden"
//                 />
//               </th>
//             </tr>
//             <tr>
//               <th className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold align-center" style={{ width: '60px' }}>
//                 <textarea
//                   rows={2}
//                   value={casualTable.data.tariffHeaders?.location || 'Location'}
//                   onChange={e => handleCasualTariffHeader('location', e.target.value)}
//                   className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none overflow-hidden"
//                 />
//               </th>
//               <th className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold align-center" style={{ width: '50px' }}>
//                 <textarea
//                   rows={2}
//                   value={casualTable.data.tariffHeaders?.hrs_0_2 || '0-2 Hrs'}
//                   onChange={e => handleCasualTariffHeader('hrs_0_2', e.target.value)}
//                   className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none overflow-hidden"
//                 />
//               </th>
//               <th className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold align-center" style={{ width: '50px' }}>
//                 <textarea
//                   rows={2}
//                   value={casualTable.data.tariffHeaders?.hrs_3_8 || '3-8 Hrs'}
//                   onChange={e => handleCasualTariffHeader('hrs_3_8', e.target.value)}
//                   className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none overflow-hidden"
//                 />
//               </th>
//               <th className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold align-center" style={{ width: '50px' }}>
//                 <textarea
//                   rows={2}
//                   value={casualTable.data.tariffHeaders?.hrs_9_24 || '9-24'}
//                   onChange={e => handleCasualTariffHeader('hrs_9_24', e.target.value)}
//                   className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none "
//                 />
//               </th>
//               <th className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold align-top" style={{ width: '50px' }}>
//                 <textarea
//                   rows={2}
//                   value={casualTable.data.tariffHeaders?.lost_ticket || 'Lost Ticket'}
//                   onChange={e => handleCasualTariffHeader('lost_ticket', e.target.value)}
//                   className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none "
//                 />
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {casualTable.data.tariffRows.map((row, i) => (
//               <tr key={i}>
//                 {['location', 'hrs_0_2', 'hrs_3_8', 'hrs_9_24', 'lost_ticket'].map(key => (
//                   <td key={key} className="!border !border-black px-1 py-1.5 text-center">
//                     <input type="text" value={row[key] || ''} onChange={e => handleCasualTariffRow(i, key, e.target.value)} className="w-full min-w-0 !border-0 bg-transparent text-center outline-none text-[9px]" />
//                   </td>
//                 ))}
//               </tr>
//             ))}
//           </tbody>
//         </table>

//       </div>

//       {/* RIGHT SIDE (Membership Tariff) */}
//       <div className="ml-2">
//         <table className="!border-collapse text-[9px] w-auto">
//           <thead>
//             <tr>
//               {membershipTable.data.columns.map((col, i) => (
//              <th
//   key={i}
//   className={`!border !border-black  font-bold text-center  
//     ${
//       (col || '').toLowerCase().includes('ramadan') ||
//       (col || '').toLowerCase().includes('employee')
//         ? 'bg-orange-200'
//         : 'bg-gray-300'
//     }`}
//   style={{ width: i === 0 ? '60px' : '70px' }}
// >
//              <textarea
//   rows={3}
//   value={col}
//   onChange={e => handleMembershipColumn(i, e.target.value)}
//   className="w-full !border-0 bg-transparent text-center outline-none text-[9px] content-center font-bold resize-none overflow-hidden leading-tight"
//   onInput={(e) => {
//     e.target.style.height = 'auto';
//     e.target.style.height = e.target.scrollHeight + 'px';
//   }}
// />
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {membershipTable.data.rows.map((row, rIdx) => (
//               <tr key={rIdx}>
//                 {row.map((cell, cIdx) => (
//                   <td key={cIdx} className="!border !border-black px-1 py-2 text-center">
//                     <input type="text" value={cell} onChange={e => handleMembershipCell(rIdx, cIdx, e.target.value)} className="w-full min-w-0 outline-none bg-transparent !border-0 text-[9px] text-center" />
//                   </td>
//                 ))}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//     </div>

//   </div>
// )}

//           {/* ── Enforcement page: Violations table ── */}
//           {pageType === 'enforcement' && enforcementTable && (
//             <div className="ml-4 mt-2 ">
//               <table className="!border-collapse text-[8px]">
//                 <thead>
//                   <tr className="bg-gray-300">
//                     {['#', 'Code', 'Cat', 'Description (EN)', 'Description (AR)', 'Fine', 'Discount', 'After Disc.', 'Grace', 'Min', 'Max', 'Reference'].map((h, i) => (
//                       <th key={i} className="!border !border-black px-1.5 py-1 font-bold text-center" style={{ minWidth: i === 3 || i === 4 ? '160px' : '40px' }}>
//                         {h}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {enforcementTable.data.rows.map((row, rIdx) => (
//                     <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : ''}>
//                       {[
//                         { key: 'sno', w: '30px' }, { key: 'code', w: '40px' }, { key: 'category', w: '35px' },
//                         { key: 'description_en', w: '160px',isLong:true }, { key: 'description_ar', w: '160px', rtl: true,isLong:true },
//                         { key: 'fine', w: '40px' }, { key: 'discount', w: '45px' }, { key: 'after_discount', w: '45px' },
//                         { key: 'grace', w: '35px' }, { key: 'min_repeat', w: '30px' }, { key: 'max_repeat', w: '30px' },
//                         { key: 'reference', w: '80px' },
//                       ].map(({ key, w, rtl,isLong }) => (
//                        <td key={key} className="!border !border-black px-1 py-0.5">
//   {isLong ? (
//     <textarea
//       value={row[key] || ''}
//       onChange={e => handleEnforcementCell(rIdx, key, e.target.value)}
//       dir={rtl ? 'rtl' : 'ltr'}
//       rows={1}
//       className="!border-0 bg-transparent outline-none text-[8px] text-left resize-none overflow-hidden"
//       style={{
//         width: w,
//         minWidth: '260px',   // same as your previous “isLong” textarea
//         minHeight: '22px',
//         lineHeight: '1.1',
//         padding: '2px 4px',
//       }}
//       onInput={e => {
//         e.target.style.height = 'auto';
//         e.target.style.height = e.target.scrollHeight + 'px';
//       }}
//     />
//   ) : (
//     <input
//       type="text"
//       value={row[key] || ''}
//       onChange={e => handleEnforcementCell(rIdx, key, e.target.value)}
//       dir={rtl ? 'rtl' : 'ltr'}
//       className="!border-0 bg-transparent outline-none text-[8px] text-center"
//       style={{ width: w }}
//     />
//   )}
// </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>

//         {/* ══ RIGHT — Assets Panel ══ */}
//         <AssetsPanel
//           assetsTable={assetsTable}
//           flatAssets={flatAssets}
//           onSubCount={handleAssetSubCount}
//           onTotalCount={handleAssetTotalCount}
//         />
//       </div>

//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
//           Saving...
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default MadinahHaramProfile;












import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
import TotalDubai from '@/assets/img/madina-haram-1.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import carParkIcon from '@/assets/img/car-park-1.png';
import { API_CALL_TIME } from '@/constants/constant';


// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ═══════════════════════════════════════════════════════════════════════
// ASSET GROUPS HELPER
// ═══════════════════════════════════════════════════════════════════════
function makeAssetGroups(o = {}) {
  return [
    { group_name: 'Ticket Dispenser', group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: o.g10064 ?? '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
    { group_name: 'Ticket Verifier', group_total_qty: o.ticketVerifier ?? '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
    { group_name: "APM's", group_total_qty: o.apms ?? '-', items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: o.apmEts100 ?? '-' }] },
    { group_name: 'PIN Pad', group_total_qty: o.pinPad ?? '-', items: [{ item_name: 'IUP250', qty: o.pinPad ?? '-' }] },
    { group_name: 'Card Reader', group_total_qty: o.cardReader ?? '-', items: [{ item_name: 'IUR250', qty: o.cardReader ?? '-' }] },
    { group_name: 'B-Contactless', group_total_qty: o.bContactless ?? '-', items: [{ item_name: 'IUC150', qty: o.bContactless ?? '-' }] },
    { group_name: 'RFID Reader', group_total_qty: o.rfidReader ?? '-', items: [] },
    { group_name: 'IP Barrier', group_total_qty: o.ipBarrier ?? '-', items: [] },
    { group_name: 'ANPR CAMERA', group_total_qty: o.anprCamera ?? '-', items: [{ item_name: 'ARH', qty: '-' }, { item_name: 'Luminera', qty: o.luminera ?? '-' }] },
    { group_name: 'Sliding Gate', group_total_qty: '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
    { group_name: "PND's", group_total_qty: '-', items: [{ item_name: 'TPAL- BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
    { group_name: 'Pound Cahier Device', group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
    { group_name: 'Driver Device', group_total_qty: '-', items: [{ item_name: 'CN-51', qty: '-' }] },
    { group_name: 'Enf Device', group_total_qty: o.enfDevice ?? '-', items: [{ item_name: 'Oukitel WP2', qty: o.oukitel ?? '-' }, { item_name: 'Doogee V10', qty: '-' }] },
    { group_name: 'Validation', group_total_qty: '-', items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
    { group_name: 'Printer', group_total_qty: o.printer ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
    { group_name: 'Tow Truck', group_total_qty: '-', items: [] },
    { group_name: 'Clamp Vehicle', group_total_qty: o.clampVehicle ?? '-', items: [] },
  ];
}

// ═══════════════════════════════════════════════════════════════════════
// CONFIG — Madinah Haram ke teeno page types
// ═══════════════════════════════════════════════════════════════════════
const MADINAH_PROFILE_CONFIG = {

  // ── Madinah Haram Profile (main profile + casual parking + membership) ──
  madinah_haram_profile: {
    profileKey: 'madinah_haram_profile',
    casualKey: 'madinah_haram_casual_parking',
    membershipKey: 'madinah_haram_membership_tariff',
    assetsKey: 'madinah_haram_assets',
    pageType: 'profile',   // profile | parking | enforcement

    profileFallback: {
      table_key: 'madinah_haram_profile',
      title: 'Madinah Haram Profile',
      data: {
        car_park_bays: { label: 'Madinah Haram Car Park Bays', value: '4272' },
        contract_term: { value: '03 years' },
        contract_period: { start_date: '01/02/2024', end_date: '31/01/2027' },
        operational_hours: { value: '24 Hours Per day' },
        parking_tariff: { value: 'As per below tariff table excluding 15% vat' },
        membership_tariff: { value: 'As per below tariff table excluding 15% vat' },
      },
    },

    casualFallback: {
      table_key: 'madinah_haram_casual_parking',
      title: 'Casual Parking Per Hour',
      data: {
        locationRows: [
          { location: 'A-1', bays: '178' }, { location: 'A-2', bays: '178' },
          { location: 'A-3', bays: '178' }, { location: 'A-4', bays: '178' },
          { location: 'A-5', bays: '178' }, { location: 'A-6', bays: '178' },
          { location: 'A-7', bays: '178' }, { location: 'A-8', bays: '178' },
          { location: 'A-9', bays: '178' }, { location: 'A-10', bays: '178' },
          { location: 'A-11', bays: '178' }, { location: 'B-1', bays: '178' },
          { location: 'B-2', bays: '178' }, { location: 'B-3', bays: '178' },
          { location: 'B-4', bays: '178' }, { location: 'B-5', bays: '178' },
          { location: 'B-6', bays: '178' }, { location: 'B-7', bays: '178' },
          { location: 'B-8', bays: '178' }, { location: 'B-9', bays: '178' },
          { location: 'B-10', bays: '178' }, { location: 'B-11', bays: '178' },
          { location: 'B-12', bays: '178' }, { location: 'B-13', bays: '178' },
        ],
        tariffRows: [
          { location: 'A-1', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-3', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-4', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-5', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-7', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-8', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-9', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-10', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-11', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-1', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-3', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-4', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-5', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-7', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-9', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-11', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-12', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
        ],
      },
    },

    membershipFallback: {
      table_key: 'madinah_haram_membership_tariff',
      title: 'Membership Tariff',
      data: {
      columns: [
  'Location',
  '1 Month Employee',
  '1 Month',
  '1 Month',
  '1 Month',
  '1 Month',
  '1 Month',
  '1 Month RAMADAN',
  '2 Months',
  '2 Months',
  '3 Months',
  '3 Months',
  '6 Months',
  '6 Months',
  '12 Months',
  '12 Months',
  '12 Months',
  '12 Months',
  '12 Months'
],
        rows: [
          ['A-2', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
          ['A-3', '100', '', '', '', '', '400', '1440', '', '', '', '', '', '', '', '', '', '', '5,120'],
          ['A-4', '100', '', '300', '', '', '', '1440', '', '', '', '', '', '', '', '4,020', '', '', ''],
          ['A-6', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
          ['B-2', '100', '', '', '350', '', '', '1440', '700', '', '1,050', '', '2,100', '', '', '', '4,570', '', ''],
          ['B-4', '100', '275', '', '', '', '', '1440', '', '', '', '', '', '', '3,745', '', '', '', ''],
          ['B-6', '100', '', '', '350', '', '', '1440', '700', '', '1,050', '', '2,100', '', '', '', '4,570', '', ''],
          ['B-8', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
          ['B-10', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
          ['B-13', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
        ],
      },
    },

    assetsFallback: {
      table_key: 'madinah_haram_assets',
      title: 'Madinah Harram Contract',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '24', g10064: '24', ticketVerifier: '26', evG10064: '26',
          apms: '48', apmEts70: '30', apmEts100: '18', pinPad: '35',
          bContactless: '35', rfidReader: '50', ipBarrier: '50', anprCamera: '50',
          luminera: '50', printer: '-', enfDevice: '-',
        }),
      },
    },
  },

  // ── Madinah Haram Parking Profile ──────────────────────────────────
  madinah_haram_parking_profile: {
    profileKey: 'madinah_haram_parking_profile',
    casualKey: 'madinah_haram_parking_casual',
    membershipKey: 'madinah_haram_parking_membership',
    assetsKey: 'madinah_haram_parking_assets',
    pageType: 'parking',

    profileFallback: {
      table_key: 'madinah_haram_parking_profile',
      title: 'Madinah Haram Parking Profile',
      data: {
        car_park_bays: { label: 'Madinah Haram Car Park Bays', value: '4272' },
        contract_term: { value: '03 years' },
        contract_period: { start_date: '01/02/2024', end_date: '31/01/2027' },
        operational_hours: { value: '24 Hours Per day' },
        parking_tariff: { value: 'As per below tariff table excluding 15% vat' },
        membership_tariff: { value: 'As per below tariff table excluding 15% vat' },
      },
    },

    casualFallback: {
      table_key: 'madinah_haram_parking_casual',
      title: 'Casual Parking Per Hour',
      data: {
        locationRows: [
          { location: 'A-1', bays: '178' }, { location: 'A-2', bays: '178' },
          { location: 'A-3', bays: '178' }, { location: 'A-4', bays: '178' },
          { location: 'A-5', bays: '178' }, { location: 'A-6', bays: '178' },
          { location: 'A-7', bays: '178' }, { location: 'A-8', bays: '178' },
          { location: 'A-9', bays: '178' }, { location: 'A-10', bays: '178' },
          { location: 'A-11', bays: '178' }, { location: 'B-1', bays: '178' },
          { location: 'B-2', bays: '178' }, { location: 'B-3', bays: '178' },
          { location: 'B-4', bays: '178' }, { location: 'B-5', bays: '178' },
          { location: 'B-6', bays: '178' }, { location: 'B-7', bays: '178' },
          { location: 'B-8', bays: '178' }, { location: 'B-9', bays: '178' },
          { location: 'B-10', bays: '178' }, { location: 'B-11', bays: '178' },
          { location: 'B-12', bays: '178' }, { location: 'B-13', bays: '178' },
        ],
        tariffRows: [
          { location: 'A-1', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-3', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-4', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-5', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-7', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-8', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-9', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-10', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'A-11', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-1', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-3', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-4', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-5', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-7', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-9', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-11', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
          { location: 'B-12', hrs_0_2: '1', hrs_3_8: '2', hrs_9_24: '3', lost_ticket: '25' },
        ],
      },
    },

    membershipFallback: {
      table_key: 'madinah_haram_parking_membership',
      title: 'Membership Tariff',
      data: {
        columns: ['Location', '1 Month Employee', '1 Month', '1 Month', '1 Month', '1 Month', '1 Month', '1 Month RAMDAN', '2 Months', '2 Months', '3 Months', '3 Months', '6 Months', '6 Months', '12 Months', '12 Months', '12 Months', '12 Months', '12 Months'],
        rows: [
          ['A-2', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
          ['A-3', '100', '', '', '', '', '400', '1440', '', '', '', '', '', '', '', '', '', '', '5,120'],
          ['A-4', '100', '', '300', '', '', '', '1440', '', '', '', '', '', '', '', '4,020', '', '', ''],
          ['A-6', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
          ['B-2', '100', '', '', '350', '', '', '1440', '700', '', '1,050', '', '2,100', '', '', '', '4,570', '', ''],
          ['B-4', '100', '275', '', '', '', '', '1440', '', '', '', '', '', '', '3,745', '', '', '', ''],
          ['B-6', '100', '', '', '350', '', '', '1440', '700', '', '1,050', '', '2,100', '', '', '', '4,570', '', ''],
          ['B-8', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
          ['B-10', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
          ['B-13', '100', '', '', '', '', '400', '1440', '', '800', '', '1,200', '', '2,400', '', '', '', '', '5,120'],
        ],
      },
    },

    assetsFallback: {
      table_key: 'madinah_haram_parking_assets',
      title: 'Madinah Harram Off-Street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '24', g10064: '24', ticketVerifier: '26', evG10064: '26',
          apms: '48', apmEts70: '30', apmEts100: '18', pinPad: '35',
          bContactless: '35', rfidReader: '50', ipBarrier: '50', anprCamera: '50',
          luminera: '50', printer: '-', enfDevice: '-',
        }),
      },
    },
  },

  // ── Madinah Haram Enforcement Profile ──────────────────────────────
  madinah_haram_enforcement_profile: {
    profileKey: 'madinah_haram_enforcement_profile',
    enforcementKey: 'madinah_haram_enforcement_violations',
    assetsKey: 'madinah_haram_enforcement_assets',
    pageType: 'enforcement',

    profileFallback: {
      table_key: 'madinah_haram_enforcement_profile',
      title: 'Madinah Haram Enforcement Profile',
      data: {
        car_park_bays: { label: 'Madinah Haram Car Park Bays', value: '4272' },
        contract_term: { value: '03 years' },
        contract_period: { start_date: '01/02/2024', end_date: '31/01/2027' },
        operational_hours: { value: '24 Hours Per day' },
        enforcement_tariff: { value: 'excluding 15% vat' },
      },
    },

    enforcementFallback: {
      table_key: 'madinah_haram_enforcement_violations',
      title: 'Enforcement Violations',
      data: {
        rows: [
          { sno: '11', code: '801', category: 'MED', description_en: 'Parked in a non-parking area', description_ar: 'الوقوف ضمن منطقة ممنوع الوقوف فيها - 801', fine: '150', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
          { sno: '12', code: '802', category: 'MED', description_en: 'Parked on pedestrian or buildings entries', description_ar: 'الوقوف عند مداخل المشاة أو مداخل المباني - 802', fine: '200', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
          { sno: '13', code: '803', category: 'MED', description_en: 'Parked on the pavement or on a pedestrian area', description_ar: 'الوقوف على الرصيف أو في مكان عبور المشاة - 803', fine: '150', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
          { sno: '14', code: '804', category: 'MED', description_en: 'Parked facing the opposite direction of traffic flow', description_ar: 'الوقوف بشكل معاكس لاتجاه السير - 804', fine: '150', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
          { sno: '15', code: '805', category: 'MED', description_en: 'Parked in an officially reserved space', description_ar: 'الوقوف في مكان تم حجزه رسمياً - 805', fine: '150', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
          { sno: '16', code: '806', category: 'MED', description_en: 'Parked in a suspended space/temporary out of use', description_ar: 'الوقوف في حيز معلق الاستخدام - 806', fine: '150', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
          { sno: '17', code: '807', category: 'MED', description_en: 'Placing obstacles or reservations on the parking space', description_ar: 'وضع حواجز أو معوقات على حيز الوقوف - 807', fine: '300', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
          { sno: '18', code: '808', category: 'MED', description_en: 'Fencing or closing a parking space without a valid permit', description_ar: 'تسوير وإغلاق موقف بدون تصريح - 808', fine: '200', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
          { sno: '19', code: '809', category: 'MED', description_en: 'Parked outside allowed time', description_ar: 'تجاوز الفترة المسموح به الإيقاف - 809', fine: '100', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
          { sno: '20', code: '810', category: 'MED', description_en: 'Parked in violation of posted signs', description_ar: 'الوقوف بشكل مخالف للوحات الإيقاف - 810', fine: '150', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
          { sno: '21', code: '811', category: 'MED', description_en: 'Parked on a fire hydrant bay', description_ar: 'الوقوف إلى جانب طلمبات الحريق بمسافة تقل عن (3) أمتر - 811', fine: '250', discount: '100', after_discount: '100', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
          { sno: '22', code: '815', category: 'MED', description_en: 'Parked in a non-parking area ? H', description_ar: 'الوقوف في موقع غير مخصص للوقوف ؟ح- 815', fine: '0', discount: '150', after_discount: '150', grace: '0', min_repeat: '1', max_repeat: '1', reference: '0000000004' },
        ],
      },
    },

    assetsFallback: {
      table_key: 'madinah_haram_enforcement_assets',
      title: 'Madinah Harram Off-Street Enf',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '-', ticketVerifier: '-', apms: '-', pinPad: '-',
          cardReader: '-', bContactless: '-', rfidReader: '-', ipBarrier: '-',
          anprCamera: '-', enfDevice: '6', oukitel: '6', printer: '4', pr3: '4',
          clampVehicle: '1',
        }),
      },
    },
  },
};


// ═══════════════════════════════════════════════════════════════════════
// PROFILE HEADER (reusable for all 3 pages)
// ═══════════════════════════════════════════════════════════════════════
const ProfileHeader = ({ pd, pageType, patchProfile, effectiveTotalBays }) => (
  <div className="flex-1 pr-4">
    {/* Car Park Bays - 🔥 READ-ONLY */}
    <div className="flex items-center gap-2 mb-1 ml-4 mt-2">
      <img src={carParkIcon} alt="car park" style={{ height: '30px', objectFit: 'contain' }} />
      <span className="text-[12px]">
        {pd.car_park_bays?.label}{' '}
        <strong>
          <input 
            type="text" 
            value={effectiveTotalBays}
            readOnly 
            disabled
            className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16 cursor-default" 
          />
        </strong>
      </span>
    </div>

    {/* Contract Term - Editable */}
    <div className="flex items-start gap-2 mb-1 ml-10">
      <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
      <span className="text-[12px] gap-06">
        Contract term{''}
        <strong><input type="text" value={pd.contract_term?.value || ''}
          onChange={e => patchProfile('contract_term', 'value', e.target.value)}
          className="font-bold outline-none bg-transparent !border-0 text-[12px] ml-2 w-13" /></strong>
        ; start date{' '}
        <strong><input type="text" value={pd.contract_period?.start_date || ''}
          onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
          className="font-bold outline-none bg-transparent !border-0 text-[12px] w-18" /></strong>
        {' to '}
        <strong><input type="text" value={pd.contract_period?.end_date || ''}
          onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
          className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
      </span>
    </div>

    {/* Operational Hours - Editable */}
    <div className="flex items-center gap-2 mb-1 ml-10">
      <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
      <span className="text-[12px]">
        Operational Hours{' '}
        <strong><input type="text" value={pd.operational_hours?.value || ''}
          onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
          className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
      </span>
    </div>

    {/* Tariff line — profile & parking: 2 lines, enforcement: 1 line - Editable */}
    {pageType !== 'enforcement' && (
      <>
        <div className="flex items-center gap-2 mb-1 ml-10">
          <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
          <span className="text-[12px]">
            Parking Tariff –{' '}
            <strong><input type="text" value={pd.parking_tariff?.value || ''}
              onChange={e => patchProfile('parking_tariff', 'value', e.target.value)}
              className="font-bold outline-none bg-transparent !border-0 text-[12px] w-64" /></strong>
          </span>
        </div>
        <div className="flex items-center gap-2 mb-1 ml-10">
          <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
          <span className="text-[12px]">
            Membership Tariff -{' '}
            <strong><input type="text" value={pd.membership_tariff?.value || ''}
              onChange={e => patchProfile('membership_tariff', 'value', e.target.value)}
              className="font-bold outline-none bg-transparent !border-0 text-[12px] w-64" /></strong>
          </span>
        </div>
      </>
    )}
    {pageType === 'enforcement' && (
      <div className="flex items-center gap-2 mb-1 ml-10">
        <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
        <span className="text-[12px]">
          <span>Enforcement violation tariff below {" "}</span>
          <strong><input type="text" value={pd.enforcement_tariff?.value || ''}
            onChange={e => patchProfile('enforcement_tariff', 'value', e.target.value)}
            className="outline-none bg-transparent !border-0 text-[12px] w-80" /></strong>
        </span>
      </div>
    )}

    {/* Assets Deployed bullet */}
    <div className="flex items-center gap-2 mb-3 ml-10">
      <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
      <span className="text-[12px]">Assets Deployed</span>
    </div>
  </div>
);

// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const MadinahHaramProfile = ({ page, year = '', month = '', monthNumber = '', contract = '' }) => {
  
  const cfg = MADINAH_PROFILE_CONFIG[page?.type];
  if (!cfg) return null;

  const hasFetchedRef = useRef(false);
  const saveRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  
  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);
  
  const [profileTable, setProfileTable] = useState(cfg.profileFallback);
  const [assetsTable, setAssetsTable] = useState(cfg.assetsFallback);
  const [casualTable, setCasualTable] = useState(cfg.casualFallback || null);
  const [membershipTable, setMembershipTable] = useState(cfg.membershipFallback || null);
  const [enforcementTable, setEnforcementTable] = useState(cfg.enforcementFallback || null);
  const { enqueue } = useApiQueue();

  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileTable?.data?.car_park_bays?.value ?? '4272';

  const profileRef = useRef(null);
  const assetsRef = useRef(null);
  const casualRef = useRef(null);
  const membershipRef = useRef(null);
  const enforcementRef = useRef(null);

  // Sync refs with latest state
  useEffect(() => {
    profileRef.current = profileTable;
  }, [profileTable]);

  useEffect(() => {
    assetsRef.current = assetsTable;
  }, [assetsTable]);

  useEffect(() => {
    casualRef.current = casualTable;
  }, [casualTable]);

  useEffect(() => {
    membershipRef.current = membershipTable;
  }, [membershipTable]);

  useEffect(() => {
    enforcementRef.current = enforcementTable;
  }, [enforcementTable]);
  
  // ── Fetch BOTH APIs ────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params
      const secondApiParams = {
        contract: "0040002",
        year: year,
        month: month,
        type: "off_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;

        setProfileTable(find(cfg.profileKey, cfg.profileFallback));
        setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));

        if (cfg.casualKey) setCasualTable(find(cfg.casualKey, cfg.casualFallback));
        if (cfg.membershipKey) setMembershipTable(find(cfg.membershipKey, cfg.membershipFallback));
        if (cfg.enforcementKey) setEnforcementTable(find(cfg.enforcementKey, cfg.enforcementFallback));
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ─────────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveRef.current) clearTimeout(saveRef.current);
    saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  const saveToAPI = async () => {
  try {
    setIsSaving(true);

    const tables = [];

    // Profile aur Assets hamesha hote hain
    if (profileRef.current) {
      tables.push({ 
        table_key: profileRef.current.table_key, 
        title: profileRef.current.title, 
        data: profileRef.current.data 
      });
    }
    if (assetsRef.current) {
      tables.push({ 
        table_key: assetsRef.current.table_key, 
        title: assetsRef.current.title, 
        data: assetsRef.current.data 
      });
    }

    if (casualRef.current) {
      tables.push({ 
        table_key: casualRef.current.table_key, 
        title: casualRef.current.title, 
        data: casualRef.current.data 
      });
    }
    if (membershipRef.current) {
      tables.push({ 
        table_key: membershipRef.current.table_key, 
        title: membershipRef.current.title, 
        data: membershipRef.current.data 
      });
    }
    if (enforcementRef.current) {
      tables.push({ 
        table_key: enforcementRef.current.table_key, 
        title: enforcementRef.current.title, 
        data: enforcementRef.current.data 
      });
    }

    const res = await apiCall('POST', '/boardpack/add-tables-data', {
      contract, 
      year, 
      month: monthNumber, 
      created_by: 1, 
      tables,
    });

    if (!res?.success) throw new Error(res?.message || 'Save failed');
    
  } catch (err) {
    console.error('Save error:', err);
    toast.error('Failed to save changes');
  } finally {
    setIsSaving(false);
  }
};

  // ── Patch helpers ─────────────────────────────────────────────────────
  const patchProfile = (field, subField, value) => {
    setProfileTable(prev => ({
      ...prev,
      data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
    }));
    autoSave();
  };

  const handleCasualLocationRow = (idx, key, value) => {
    setCasualTable(prev => ({
      ...prev,
      data: { ...prev.data, locationRows: prev.data.locationRows.map((r, i) => i === idx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleCasualTariffRow = (idx, key, value) => {
    setCasualTable(prev => ({
      ...prev,
      data: { ...prev.data, tariffRows: prev.data.tariffRows.map((r, i) => i === idx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleMembershipCell = (rIdx, cIdx, value) => {
    setMembershipTable(prev => ({
      ...prev,
      data: {
        ...prev.data,
        rows: prev.data.rows.map((r, i) => i === rIdx ? r.map((c, j) => j === cIdx ? value : c) : r),
      },
    }));
    autoSave();
  };

  const handleEnforcementCell = (rIdx, key, value) => {
    setEnforcementTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleAssetSubCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const handleAssetTotalCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const handleCasualLocationHeader = (col, value) => {
  setCasualTable(prev => ({
    ...prev,
    data: { ...prev.data, locationHeader: { ...prev.data.locationHeader, [col]: value } },
  }));
  autoSave();
};

const handleCasualTariffHeader = (key, value) => {
  setCasualTable(prev => ({
    ...prev,
    data: { ...prev.data, tariffHeaders: { ...prev.data.tariffHeaders, [key]: value } },
  }));
  autoSave();
};

const handleMembershipColumn = (index, value) => {
  setMembershipTable(prev => {
    const newColumns = [...prev.data.columns];
    newColumns[index] = value;
    return { ...prev, data: { ...prev.data, columns: newColumns } };
  });
  autoSave();
};

  // ── Derived ───────────────────────────────────────────────────────────
  const pd = profileTable.data;
  const flatAssets = groupsToFlat(assetsTable.data.groups);
  const pageType = cfg.pageType;

  // ═══════════════════════════════════════════════════════════════════
  // RENDER
  // ═══════════════════════════════════════════════════════════════════
  const groupedColumns = [
  { label: 'Location', span: 1 },
  { label: '1 Month Employee', span: 1 },
  { label: '1 Month', span: 5 },
  { label: '1 Month RAMDAN', span: 1 },
  { label: '2 Months', span: 2 },
  { label: '3 Months', span: 2 },
  { label: '6 Months', span: 2 },
  { label: '12 Months', span: 5 },
];
  return (
    <div className="min-h-screen p-8 bg-white">
      {/* Header */}
      <div className="flex justify-between items-center mb-2">
        <div className="ml-2">
          {/* Replace with your Madinah logo import */}
          <img src={TotalDubai} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} />        </div>
        <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
      </div>

      <div className="flex flex-row gap-0 !border-2 !border-black p-3">

        {/* ══ LEFT ══ */}
        <div className="flex-1">
          <ProfileHeader pd={pd} pageType={pageType} patchProfile={patchProfile} effectiveTotalBays={effectiveTotalBays} />

         {/* { ── Profile & Parking pages: Casual + Membership tables ──} */}
{(pageType === 'profile' || pageType === 'parking') && casualTable && membershipTable && (
  <div className="flex flex-row gap-3 ml-4 ">

    {/* Casual Parking — left side (location list + tariff) */}
    <div className="flex items-start gap-3 w-full">

      {/* LEFT SIDE (Location + Tariff) */}
      <div className="flex gap-2">

        {/* Location + Bays column */}
        <table className="!border-collapse text-[9px] w-auto">
          <thead>
            <tr>
              <th className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold align-center" style={{ width: '70px' }}>
                <textarea
                  rows={2}
                  value={casualTable.data.locationHeader?.col1 || 'Location'}
                  onChange={e => handleCasualLocationHeader('col1', e.target.value)}
                  className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none overflow-hidden"
                />
              </th>
              <th className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold align-center" style={{ width: '80px' }}>
                <textarea
                  rows={2}
                  value={casualTable.data.locationHeader?.col2 || `Parking Bays ${effectiveTotalBays}`}
                  onChange={e => handleCasualLocationHeader('col2', e.target.value)}
                  className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none overflow-hidden"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {casualTable.data.locationRows.map((row, i) => (
              <tr key={i}>
                <td className="!border !border-black px-1 py-0.5 text-center">
                  <input type="text" value={row.location || ''} onChange={e => handleCasualLocationRow(i, 'location', e.target.value)} className="w-full min-w-0 !border-0 bg-transparent text-center outline-none text-[9px]" />
                </td>
                <td className="!border !border-black px-1 py-0.5 text-center">
                  <input type="text" value={row.bays || ''} onChange={e => handleCasualLocationRow(i, 'bays', e.target.value)} className="w-full min-w-0 !border-0 bg-transparent text-center outline-none text-[9px]" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Tariff columns - Editable */}
        <table className="!border-collapse text-[9px] w-auto">
          <thead>
            <tr>
              <th colSpan={5} className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold">
                <textarea
                  rows={2}
                  value={casualTable.title || ''}
                  onChange={e => { setCasualTable(prev => ({ ...prev, title: e.target.value })); autoSave(); }}
                  className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none overflow-hidden"
                />
              </th>
            </tr>
            <tr>
              <th className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold align-center" style={{ width: '60px' }}>
                <textarea
                  rows={2}
                  value={casualTable.data.tariffHeaders?.location || 'Location'}
                  onChange={e => handleCasualTariffHeader('location', e.target.value)}
                  className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none overflow-hidden"
                />
              </th>
              <th className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold align-center" style={{ width: '50px' }}>
                <textarea
                  rows={2}
                  value={casualTable.data.tariffHeaders?.hrs_0_2 || '0-2 Hrs'}
                  onChange={e => handleCasualTariffHeader('hrs_0_2', e.target.value)}
                  className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none overflow-hidden"
                />
              </th>
              <th className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold align-center" style={{ width: '50px' }}>
                <textarea
                  rows={2}
                  value={casualTable.data.tariffHeaders?.hrs_3_8 || '3-8 Hrs'}
                  onChange={e => handleCasualTariffHeader('hrs_3_8', e.target.value)}
                  className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none overflow-hidden"
                />
              </th>
              <th className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold align-center" style={{ width: '50px' }}>
                <textarea
                  rows={2}
                  value={casualTable.data.tariffHeaders?.hrs_9_24 || '9-24'}
                  onChange={e => handleCasualTariffHeader('hrs_9_24', e.target.value)}
                  className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none "
                />
              </th>
              <th className="!border !border-black px-1 py-1 bg-gray-300 text-center font-bold align-top" style={{ width: '50px' }}>
                <textarea
                  rows={2}
                  value={casualTable.data.tariffHeaders?.lost_ticket || 'Lost Ticket'}
                  onChange={e => handleCasualTariffHeader('lost_ticket', e.target.value)}
                  className="w-full !border-0 bg-transparent text-center outline-none text-[9px] font-bold resize-none "
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {casualTable.data.tariffRows.map((row, i) => (
              <tr key={i}>
                {['location', 'hrs_0_2', 'hrs_3_8', 'hrs_9_24', 'lost_ticket'].map(key => (
                  <td key={key} className="!border !border-black px-1 py-1.5 text-center">
                    <input type="text" value={row[key] || ''} onChange={e => handleCasualTariffRow(i, key, e.target.value)} className="w-full min-w-0 !border-0 bg-transparent text-center outline-none text-[9px]" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

      </div>

      {/* RIGHT SIDE (Membership Tariff) - Editable */}
      <div className="ml-2">
        <table className="!border-collapse text-[9px] w-auto">
          <thead>
            <tr>
              {membershipTable.data.columns.map((col, i) => (
             <th
  key={i}
  className={`!border !border-black font-bold text-center  
    ${
      (col || '').toLowerCase().includes('ramadan') ||
      (col || '').toLowerCase().includes('employee')
        ? 'bg-orange-200'
        : 'bg-gray-300'
    }`}
  style={{ width: i === 0 ? '60px' : '70px' }}
>
             <textarea
  rows={3}
  value={col}
  onChange={e => handleMembershipColumn(i, e.target.value)}
  className="w-full !border-0 bg-transparent text-center outline-none text-[9px] content-center font-bold resize-none overflow-hidden leading-tight"
  onInput={(e) => {
    e.target.style.height = 'auto';
    e.target.style.height = e.target.scrollHeight + 'px';
  }}
/>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {membershipTable.data.rows.map((row, rIdx) => (
              <tr key={rIdx}>
                {row.map((cell, cIdx) => (
                  <td key={cIdx} className="!border !border-black px-1 py-2 text-center">
                    <input type="text" value={cell} onChange={e => handleMembershipCell(rIdx, cIdx, e.target.value)} className="w-full min-w-0 outline-none bg-transparent !border-0 text-[9px] text-center" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>

  </div>
)}

          {/* ── Enforcement page: Violations table (Editable) ── */}
          {pageType === 'enforcement' && enforcementTable && (
            <div className="ml-4 mt-2 ">
              <table className="!border-collapse text-[8px]">
                <thead>
                  <tr className="bg-gray-300">
                    {['#', 'Code', 'Cat', 'Description (EN)', 'Description (AR)', 'Fine', 'Discount', 'After Disc.', 'Grace', 'Min', 'Max', 'Reference'].map((h, i) => (
                      <th key={i} className="!border !border-black px-1.5 py-1 font-bold text-center" style={{ minWidth: i === 3 || i === 4 ? '160px' : '40px' }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {enforcementTable.data.rows.map((row, rIdx) => (
                    <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : ''}>
                      {[
                        { key: 'sno', w: '30px' }, { key: 'code', w: '40px' }, { key: 'category', w: '35px' },
                        { key: 'description_en', w: '160px',isLong:true }, { key: 'description_ar', w: '160px', rtl: true,isLong:true },
                        { key: 'fine', w: '40px' }, { key: 'discount', w: '45px' }, { key: 'after_discount', w: '45px' },
                        { key: 'grace', w: '35px' }, { key: 'min_repeat', w: '30px' }, { key: 'max_repeat', w: '30px' },
                        { key: 'reference', w: '80px' },
                      ].map(({ key, w, rtl,isLong }) => (
                       <td key={key} className="!border !border-black px-1 py-0.5">
  {isLong ? (
    <textarea
      value={row[key] || ''}
      onChange={e => handleEnforcementCell(rIdx, key, e.target.value)}
      dir={rtl ? 'rtl' : 'ltr'}
      rows={1}
      className="!border-0 bg-transparent outline-none text-[8px] text-left resize-none overflow-hidden"
      style={{
        width: w,
        minWidth: '220px',   // same as your previous “isLong” textarea
        minHeight: '22px',
        lineHeight: '1.1',
        padding: '2px 4px',
      }}
      onInput={e => {
        e.target.style.height = 'auto';
        e.target.style.height = e.target.scrollHeight + 'px';
      }}
    />
  ) : (
    <input
      type="text"
      value={row[key] || ''}
      onChange={e => handleEnforcementCell(rIdx, key, e.target.value)}
      dir={rtl ? 'rtl' : 'ltr'}
      className="!border-0 bg-transparent outline-none text-[8px] text-center"
      style={{ width: w }}
    />
  )}
</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* ══ RIGHT — Assets Panel ══ */}
        <AssetsPanel
          assetsTable={assetsTable}
          flatAssets={flatAssets}
          onSubCount={handleAssetSubCount}
          onTotalCount={handleAssetTotalCount}
        />
      </div>
    </div>
  );
};

export default MadinahHaramProfile;